"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLockScrolling = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const useLockScrolling = (lock) => {
    React.useEffect(() => {
        const html = document.querySelector('html');
        if (html) {
            if (lock)
                html.style.overflow = 'hidden';
            else
                html.style.overflow = '';
        }
    }, [lock]);
};
exports.useLockScrolling = useLockScrolling;
